import { render, staticRenderFns } from "./SessionColumn.vue?vue&type=template&id=48942e4a&scoped=true&"
import script from "./SessionColumn.vue?vue&type=script&lang=js&"
export * from "./SessionColumn.vue?vue&type=script&lang=js&"
import style0 from "./SessionColumn.vue?vue&type=style&index=0&id=48942e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48942e4a",
  null
  
)

export default component.exports